import React from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { permissionToPartnerFormWrapperConnection } from "shared/forms/LimitedToTeams/visible-to-partners-limited-to-teams-form-wrapper-selectors"
import DesktopLimitedToTeamsFormWrapper from "app/static/frontend/forms/components/DesktopLimitedToTeamsFormWrapper"
import { HorizontalFormStep } from "quorumdesign"

import hideIfTrue from "imports/hideIfTrue"

// this component renders both the LimitedToTeamsFormWrapper, as well as a toggle for sharing externally (when we support that)
// otherwise should just be DesktopLimitedToTeamsFormWrapper (with design system FormStep)
export const ShareExternallyLimitedToTeamsFormWrapper = props => props.shouldRenderFormSection
    ? (
        <div
            className={'form-wrapper-hide-wrapper'}
            style={hideIfTrue(props.shouldHideTeamPermissioningFormComponent)}
        >
            <HorizontalFormStep
                step={props.step}
                label={props.formLabel}
                overrideFormStepClass
            >
                { /* This component is used in the rest of the Forms. We pass a flag
                    To let the component know that we want the parent component to render the FormStep wrapper
                */ }
                <DesktopLimitedToTeamsFormWrapper
                    shouldParentManageFormStep
                    canPermissionToPartners
                    {...props}
                />
                { /* This should eventually show the sharing externally toggle  */ }
            </HorizontalFormStep>
        </div>
    )
    : null


ShareExternallyLimitedToTeamsFormWrapper.propTypes = {
    change: PropTypes.func.isRequired,
    formLabel: PropTypes.string.isRequired,
    reduxFormKey: PropTypes.string.isRequired,
    shouldHideTeamPermissioningFormComponent: PropTypes.bool,
    shouldRenderFormSection: PropTypes.bool.isRequired,
    step: PropTypes.number.isRequired,
}

ShareExternallyLimitedToTeamsFormWrapper.defaultProps = {
    shouldHideTeamPermissioningFormComponent: false,
}

export default connect(permissionToPartnerFormWrapperConnection)(ShareExternallyLimitedToTeamsFormWrapper)
